import React from 'react'
import PropTypes from 'prop-types'
import omit from 'lodash/omit'
import Row from '../../common/Row'
import Spacer from '../../common/Spacer'
import ClickIcon from '../../common/ClickIcon'

const VARIANTS = {
    whatsapp: 'whatsapp',
    facebook: 'facebook',
    // instagram: 'instagram',
    // email: 'email',
    native: 'native',
}

const THEMES = {
    light: 'Light',
    dark: 'Dark',
}

const ICON_SIZE = 50

/**
 *
 * Content
 *    message - a message to share
 * iOS
 *     url - an URL to share
 * At least one of URL and message is required.
 * Android
 *     title - title of the message
 * Options
 * iOS
 *     subject - a subject to share via email
 *     excludedActivityTypes
 *     tintColor
 */

const Share = ({
    shareContent,
    onShare,
    theme,
}) => {

    const handleNativeShare = async () => {
        try {

            if (navigator.share) {
                navigator.share({
                    title: 'Tribaldata',
                    text: `${shareContent.message}\n\n${shareContent.url}`,
                    url: shareContent.url,
                })
            }

            onShare(VARIANTS.native)

        } catch (e) {
            console.log(e)
        }
    }

    const handleCustomShare = async (variant) => {
        const msg = `${shareContent.message} ${shareContent.url}`

        const urls = {
            [VARIANTS.whatsapp]: `https://api.whatsapp.com/send?phone=&source=&data=&text=${msg}`,
            [VARIANTS.facebook]: `https://www.facebook.com/sharer/sharer.php?u=${shareContent.url}&t=${shareContent.title}`,
            [VARIANTS.instagram]: 'https://www.instagram.com',
            [VARIANTS.email]: `mailto:?subject=${shareContent.title}&body=${msg}`,
        }

        try {
            window.open(urls[variant], '_blank')
            onShare(variant)
        } catch (e) {
            console.log(e)
        }
    }

    const items = []
    const omitButtons = []

    if (navigator.share == null) {
        // Remove native share if browser doesn't support it
        omitButtons.push(VARIANTS.native)
    }
    const buttonsList = omit(VARIANTS, omitButtons)

    const { length } = Object.values(buttonsList)

    Object.values(buttonsList).forEach((variant, index) => {
        items.push(
            <ClickIcon
                key={variant}
                iconName={`${variant}ShareIcon${THEMES[theme]}@2x.png`}
                width={ICON_SIZE}
                onClick={async () => {
                    if (variant === VARIANTS.native) {
                        await handleNativeShare()
                    } else {
                        await handleCustomShare(variant)
                    }
                }}
            />,
        )

        if (index < (length - 1)) {
            items.push(<Spacer key={`spacer-${variant}`} row size="XXXL" />)
        }
    })

    return (
        <Row alignItems="center" justifyContent="center">
            {items}
        </Row>
    )
}

Share.propTypes = {
    shareContent: PropTypes.shape({
        title: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
        subject: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
    }).isRequired,
    onShare: PropTypes.func,
    theme: PropTypes.oneOf(Object.keys(THEMES)),
}

Share.defaultProps = {
    onShare: () => { },
    theme: 'light',
}

export default Share
